import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLimitedAccess = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.06667 0H14.9333C15.52 0 16 0.48 16 1.06667V10.6667C16 11.2533 15.52 11.7333 14.9333 11.7333H8.97067L5.024 15.6907C4.832 15.8827 4.56533 16 4.26667 16C3.68 16 3.2 15.52 3.2 14.9333V11.7333H1.06667C0.48 11.7333 0 11.2533 0 10.6667V1.06667C0 0.48 0.48 0 1.06667 0ZM6.08758 3.2L8.35055 5.46297L10.6135 3.20001L11.3678 3.95426L9.1048 6.21721L11.3673 8.47973L10.6131 9.23398L8.35055 6.97146L6.08802 9.23399L5.33377 8.47974L7.5963 6.21721L5.33333 3.95425L6.08758 3.2Z",
		fill: "#DA1F00"
	})
});
export default SvgLimitedAccess;
